import { useContext } from 'react';
import IdentityContext from '../contexts/IdentityContext';

export default function useTranslationRole() {
  const { identity } = useContext(IdentityContext);
  return { role: identity.isTeacherAlike ? 'TEACHER' : 'STUDENT' };
}
